var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landingPage"},[(_vm.user)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.trainingHtml)}})])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }